document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[target="_blank"]').forEach(a => {
		a.classList.add('inline-flex', 'gap-4');
		a.insertAdjacentHTML('beforeend', `<svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
			<path d="M11.8846 16.3386L25.8911 2.11829" stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
			<path d="M16.7563 1.5H25.7851C26.1801 1.5 26.5 1.84499 26.5 2.27116V12.0106" stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
			<path d="M10.7251 2.7691H3.29894C2.30582 2.7691 1.5 3.6082 1.5 4.64234V25.6268C1.5 26.6609 2.30582 27.5 3.29894 27.5H23.4511C24.4442 27.5 25.2501 26.6609 25.2501 25.6268V17.8939" stroke="currentColor" stroke-width="3" stroke-miterlimit="10" stroke-linecap="round"/>
		</svg>`);
	});
});
